//////// Local storage labels Start /////

export const CouponCodeTxt   = "CouponCode";
export const totalPriceTxt   = "totalPrice";
export const totalQtyTxt     = "totalQty";
export const cartItemsTxt    = "cartItems";
export const customerDetailsTxt = "customerDetails";

//////// Local storage labels End /////